export default "__VITE_ASSET__CTlItrhQ__"